import React, { useRef, useState } from 'react';
import { Select } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import { capitalizeFirstLetter } from '../../common/utils';
import type { BaseSelectRef } from 'rc-select';

export const CustomSelect: React.FC<{
  options: string[];
  selectedOption: string;
  selectOption: (option: string) => void;
  getTitle?: (option: string) => string;
  width?: string;
  className?: string;
}> = ({ options, selectedOption, selectOption, getTitle, width, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<BaseSelectRef>(null);
  const handleSuffixClick = () => {
    setIsOpen(!isOpen);
    if (selectRef.current) {
      if (isOpen) {
        selectRef.current.blur();
      } else {
        selectRef.current.focus();
      }
    }
  };

  return (
    <div className={`flex ${className}`}>
      <Select
        ref={selectRef}
        open={isOpen}
        onDropdownVisibleChange={setIsOpen}
        onChange={(option) => {
          selectOption(option);
        }}
        showSearch={false}
        autoFocus={true}
        value={selectedOption}
        options={options.map((option) => {
          return {
            label: (
              <div className="text-brand-grey-dark text-sm font-normal leading-tight">
                {getTitle ? getTitle(option) : capitalizeFirstLetter(option)}
              </div>
            ),
            value: option,
          };
        })}
        size="small"
        popupMatchSelectWidth={false}
        suffixIcon={
          <CaretDownOutlined
            onClick={(e) => {
              e.stopPropagation();
              handleSuffixClick();
            }}
            style={{ cursor: 'pointer' }}
          />
        }
        style={{ width: width ?? '100%' }}
      ></Select>
    </div>
  );
};
